import { CTAButton as UiCTAButton, styled, styledForMobile } from "@l2r-front/l2r-ui"

import { ReferentialMap as L2RReferentialMap } from "../ReferentialMap"

export const ReferentialMap = styledForMobile(L2RReferentialMap)({
    height: "100%",
    width: "100%",
})

export const CTAButton = styledForMobile(UiCTAButton)(({ isMobile }) => ({
    flex: isMobile && "1 1 auto",
}))

export const LayerIndicator = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["surfaces/surface-primary"].main,
    borderRadius: theme.spacing(3),
    left: theme.spacing(4),
    padding: theme.spacing(2),
    position: "absolute",
    top: theme.spacing(4),
    zIndex: 10,
}))

export const SelectedInfos = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["surfaces/surface-primary"].main,
    borderRadius: theme.spacing(3),
    color: theme.palette.text.primary,
    display: "flex",
    flexDirection: "column",
    fontWeight: theme.typography.fontWeightMedium,
    left: 16,
    padding: theme.spacing(2),
    position: "absolute",
    top: 16,
}))